import DOMPurify from "dompurify"

export function sanitizeHTML(html: string) {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "b",
      "i",
      "u",
      "a",
      "ul",
      "ol",
      "li",
      "strong",
      "em",
      "span",
      "p",
      "br",
      "hr",
      "s",
      "mark",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "class", "style"],
  })
}
